export default __webpack_public_path__ + "static/logo-8cdd1f81290ef67ea3d6c7adeb8ae55f.png";